import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// get account statement
export const getAccountStatement = createAsyncThunk(
  "accountStatment/getAccountStatement",
  async (params, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      if (!params?.account_id) {
        throw new Error("account_id is required");
      }
      const queryParams = new URLSearchParams();
      queryParams.append("account_id", params.account_id);
      if (params.start_date)
        queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (params.page) queryParams.append("page", params.page);
      const url = `${BASE_URL}/accounting-reports/account-statement?${queryParams.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return { data: response.data, params };
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to get account statement!";
      return rejectWithValue(message);
    }
  },
);
